<template>
  <tbody>
    <tr class="tr-edit" :class="{ 'edit-hidden': !editType }">
      <td :colspan="cardObject.column">
        <span @click="submit(true)" class="determine">确定</span>
        <span @click="submit(false)" class="cancel">取消</span>
      </td>
    </tr>
    <template v-if="cardObject.row > 0">
      <tr
        class="card-row"
        v-for="(line, i) in cardObject.tableData"
        :key="i + 'status-card'"
      >
        <td
          class="card-grid"
          :class="{
            'grid-text-edit': [
              'textedit',
              'texteditarr',
              'gridarea',
              'gridselect',
              'datepicker',
              'imageshow'
            ].includes(item.type),
            'fill-all': ['mergegrid', 'rank'].includes(item.type),
            'grid-text': ['text'].includes(item.type)
          }"
          v-for="(item, j) in line"
          :key="j + 'status-card-grid'"
          :colspan="item.x > 1 ? item.x : 1"
          :rowspan="item.y > 1 ? item.y : 1"
          :style="item.style"
        >
          <grid-item
            :grid="item"
            :editType="editType"
            :clickEventManger="clickEventManger"
          ></grid-item>
        </td>
      </tr>
    </template>
  </tbody>
</template>
<script>
import GridItem from './Grid/index.vue'
export default {
  name: 'table-body',
  methods: {
    async submit (type) {
      if (type) {
        // 卡片编辑确定按钮
        this.clickEventManger.emit('submit')
        const checkoutType = this.checkValueResult()
        if (!checkoutType) {
          this.$message.error('数据格式错误')
          return false
        }
        this.cardObject.setLoading(true)
        this.$forceUpdate()
        const res = await this.cardObject.updateHttpData()
        if (res) {
          this.$emit('update:editType', false)
          // this.cardObject.uploadValueAll()
          // this.cardObject.setEditTypeAll(false)
        }
        this.cardObject.setLoading(false)
      } else {
        // 卡片编辑取消按钮
        this.clickEventManger.emit('cancel')
        this.$emit('update:editType', false)
        this.cardObject.setEditTypeAll(false)
        this.cardObject.resetEditValueAll()
      }
    },
    // 校验数据格式验证结果
    checkValueResult () {
      // 只有文本框、文本域需要校验
      const list = ['textedit', 'texteditarr', 'gridarea']
      return this.cardObject.tableData.every(d => {
        return d.every(s => {
          if (list.includes(s.type)) {
            return s.noCheckError
          }
          return true
        })
      })
    }
  },
  components: {
    GridItem
  },
  props: {
    editType: {
      type: Boolean,
      default: false
    },
    cardObject: {
      type: Object
    },
    clickEventManger: {
      type: Object
    }
  }
}
</script>
<style lang="scss" scoped>
@import './main.scss';
.edit-hidden {
  height: 0px !important;
  line-height: 0px !important;
  td {
    display: none;
  }
}
.tr-edit {
  width: 1000px;
  height: $table-height;
  line-height: 50px;
  text-align: center;
  background: rgba(0, 122, 255, 0.1);
  font-size: 16px;
  font-weight: 400;
  @include out-line();
  .determine {
    width: max-content;
    height: 30px;
    background: #007aff;
    border-radius: 3px;
    color: #ffffff;
    padding: 4px 24px;
    cursor: pointer;
  }
  .cancel {
    height: 30px;
    width: max-content;
    color: #007aff;
    margin-left: 15px;
    cursor: pointer;
  }
}
.card-row {
  width: 100%;
  td {
    padding-left: 15px;
  }
  .card-grid {
    height: $table-height;
    vertical-align: middle;
    box-sizing: border-box;
    text-align: left;
    font-size: 18px;
    line-height: 21px;
    font-weight: 400;
    color: #4a4a4a;
    @include inner-line();
  }
  .grid-text-edit {
    padding: 0 10px;
  }
  .fill-all {
    padding: 0;
  }
  .grid-text {
    padding-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/student-status-card/components/StatusCard/components/CTd.vue